export function getSortArray(value, array) {
  if (value.slice(-5) === " Desc") {
    const sortFd = value.slice(0, -5);
    return array.sort((a, b) =>
      b[sortFd].hasOwnProperty("seconds")
        ? new Date(b[sortFd].seconds * 1000)
            .toISOString()
            .localeCompare(new Date(a[sortFd].seconds * 1000).toISOString())
        : typeof b[sortFd] === "number"
        ? b[sortFd] - a[sortFd]
        : b[sortFd].localeCompare(a[sortFd])
    );
  } else {
    return array.sort((a, b) =>
      a[value].hasOwnProperty("seconds")
        ? new Date(a[value].seconds * 1000)
            .toISOString()
            .localeCompare(new Date(b[value].seconds * 1000).toISOString())
        : typeof a[value] === "number"
        ? a[value] - b[value]
        : a[value].localeCompare(b[value])
    );
  }
}
